import classes from "./transaction-history-container.module.css";

function Refresh({ onRefresh }) {
  return (
    <div className={classes.refresh} onClick={onRefresh}>
      <img
        src="/hire/credit-refresh-new.svg"
        alt="refresh-icon"
        width={17}
        height={17}
        className={classes.refreshIcon}
      />
      Refresh
    </div>
  );
}

export default Refresh;
